import { useError } from '../../state/useError';
import { ApiResponseStatus } from '../../../utilities/constants/common';
import { IResponseData } from '../../../typings/common';
import { logError } from '../../../utilities/helpers/errors';
import { ErrorPhrase } from '../../../utilities/constants/phrases';

export type TError = unknown;

const isDataWithStatus = (data: unknown): data is IResponseData<typeof data> =>
  (data as IResponseData<typeof data>) &&
  (data as IResponseData<typeof data>).status !== undefined;

export const useHandleErrors = () => {
  const { setError } = useError();

  const handleErrorsOnSuccess = <TData>(data: TData) => {
    if (!isDataWithStatus(data)) {
      return;
    }

    const textStatus = data.message ?? ErrorPhrase.DEFAULT_ERROR;

    if (data.status !== ApiResponseStatus.SUCCESS) {
      logError(new Error('Error in handleErrorsOnSuccess'), {
        statusCode: data.status,
        textStatus,
      });
      setError(textStatus);
    }
  };

  const handleErrorsOnError = (error: TError) => {
    const { response } = JSON.parse(JSON.stringify(error));
    const textStatus = response?.message ?? ErrorPhrase.DEFAULT_ERROR;

    setError(textStatus);
    logError(
      new Error('Error in handleErrorsOnError'),
      isDataWithStatus(response)
        ? {
            statusCode: response.status,
            textStatus,
          }
        : {}
    );
  };

  return { handleErrorsOnSuccess, handleErrorsOnError };
};
